import { getFromSnake } from '@/helpers/functions/getFromSnake'

export function getSocialCaptionFluxCode (universe) {
  return universe === 'VO' ? 'SAISIE_VO' : 'SAISIE_IMMO'
}

/**
 * Détermine si la source SOCIAL_NETWORK doit être forcée à l'enregistrement.
 * Cas des annonceurs en flux passerelle sans émetteur saisie_*.
 */
export function needsSocialNetworkSource (sitimmoUser) {
  if (!sitimmoUser) {
    return false
  }

  return !getFromSnake(sitimmoUser, 'saisit_annonces_en_ligne')
    && !getFromSnake(sitimmoUser, 'saisit_en_ligne_et_flux')
}

/**
 * Payload flux/source pour le patch caption.
 * - Saisie en ligne : flux SAISIE_* (protège contre écrasement passerelle)
 * - Flux only : flux émetteur de l'annonce + source SOCIAL_NETWORK
 *   (SAISIE_* et flux.code SOCIAL_NETWORK sont invalides pour ces clients)
 */
export function buildSocialNetworkPatchPayload (universe, isNeedSocialNetwork, emission = null) {
  if (isNeedSocialNetwork) {
    const fluxCode = (emission && emission.codeName) || (emission && emission.code)
    const payload = {
      flux: {
        code: fluxCode
      },
      source: {
        code: 'SOCIAL_NETWORK'
      }
    }

    if (emission && emission.id) {
      payload.flux.emissionId = emission.id
    }

    return payload
  }

  return {
    flux: {
      code: getSocialCaptionFluxCode(universe)
    }
  }
}
